/**
 * Tiny WebAudio chime used when a new WhatsApp message arrives in real time.
 * No audio asset required — synthesized with oscillators.
 */
let audioContext: AudioContext | null = null;

export function playNotificationSound(): void {
    try {
        if (typeof window === 'undefined') {
            return;
        }

        audioContext ??= new AudioContext();
        const ctx = audioContext;

        if (ctx.state === 'suspended') {
            void ctx.resume();
        }

        const now = ctx.currentTime;

        // Two-note ascending chime (A5 → D6).
        [880, 1174.66].forEach((frequency, index) => {
            const oscillator = ctx.createOscillator();
            const gain = ctx.createGain();

            oscillator.type = 'sine';
            oscillator.frequency.value = frequency;

            const start = now + index * 0.12;
            gain.gain.setValueAtTime(0.0001, start);
            gain.gain.exponentialRampToValueAtTime(0.12, start + 0.02);
            gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.35);

            oscillator.connect(gain);
            gain.connect(ctx.destination);

            oscillator.start(start);
            oscillator.stop(start + 0.4);
        });
    } catch {
        // Audio unavailable (autoplay policy, no AudioContext) — ignore.
    }
}
